var render = function render(){var _vm=this,_c=_vm._self._c;return (this.videopath)?_c('video',{attrs:{"width":"100%","height":"150px","controls":""}},[_c('source',{attrs:{"src":this.videopath,"type":"video/mp4"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }